export default "__VITE_ASSET__DHvbr$JT__"